export const CustomerGrantStatusTypeEnum = Object.freeze({
  Pending: 'pending',
  Rejected: 'rejected',
  Confirmed: 'confirmed',
});
